import type { CSSProperties } from 'react';
import {
  getTimeOfDayMs,
  isOverlappingDateRange,
  isSameDate,
  isWeekend,
} from '@witmetrics/utils/time';
import { mapToKey, sortByDueAt } from '@witmetrics/utils/arrays';
import type { AgendaTask } from './types';

export const classes = {
  wrapper: 'relative py-12 h-full min-h-0',
};

export function getHours() {
  let result = [];
  for (let i = 0; i < 24; i++) {
    result.push(i);
  }
  return result;
}

export function isOffHour(hour: number, date: string) {
  return isWeekend(date) || hour < 8 || hour > 18;
}

export function getCurrentTasks(date: string, tasks: AgendaTask[]) {
  return sortByDueAt(tasks.filter(({ task }) => isSameDate(task.dueAt, date)));
}

export function sortEvents(tasks: AgendaTask[], leftOffset = 0) {
  let result: {
    agendaTask: AgendaTask;
    style: CSSProperties;
  }[] = [];
  tasks.forEach((at) => {
    const start = new Date(at.task.dueAt);
    let end = new Date(at.task.dueAt);
    end.setHours(end.getHours() + 1);
    const overlaps = getOverlaps(tasks, start.toISOString(), end.toISOString());
    result.push({
      agendaTask: at,
      style: {
        width: `calc((100% - ${leftOffset}px) / ${overlaps.length})`,
        left: `calc(${leftOffset}px + ${overlaps.indexOf(
          at.task.id
        )} * ((100% - ${leftOffset}px) / ${overlaps.length}))`,
      },
    });
  });
  return result;
}

function getOverlaps(tasks: AgendaTask[], startsAt: string, endsAt: string) {
  return mapToKey(
    tasks.filter(({ task }) => {
      let taskEnd = new Date(task.dueAt);
      taskEnd.setHours(taskEnd.getHours() + 1);
      return isOverlappingDateRange(
        [startsAt, endsAt],
        [task.dueAt, taskEnd.toISOString()]
      );
    }),
    'taskId'
  );
}

export function getOffsetHeight(hourHeight: number) {
  // Scrolling to 1 hour before the current time
  const totalLength = 24 * 60 * 60 * 1000; // 24 hours to ms
  return 24 * hourHeight * (getTimeOfDayMs() / totalLength) - hourHeight;
}
